import { useModulePermission } from '../../../hooks/usePermission';
import { Modules } from '../../../constants/permissions';

/**
 * P9207 module permission hook
 * pgCode = "pw9207f1" (SYS_Program)
 */
export function useP9207Permissions() {
  return useModulePermission(Modules.P9207);
}
